<template>
  <div>
    <!-- 搜索框 -->
    <a-card title="告警历史记录列表">
        
      <a-form layout="inline" @submit="handleSubmit" :form="form">
          <a-form-item label="告警名称">
              <a-input  v-model="searchP.alertname"  placeholder="告警名称" ></a-input>
          </a-form-item>
          <a-form-item label="通道">
                <a-select v-model="searchP.blockstatus"  placeholder="" style="width:100px;">
                    <a-select-option value="">
                      全部
                    </a-select-option>
                    <a-select-option value="短信">
                       短信
                    </a-select-option>
                    <a-select-option value="邮件">
                        邮件 
                    </a-select-option>
                    <a-select-option value="钉钉">
                        钉钉
                    </a-select-option>
                </a-select>
          </a-form-item>
          <a-form-item>
                <a-button type="primary" htmlType="submit" :key="this.loading.key">筛选</a-button>
          </a-form-item>

          <a-form-item>
                <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                </a-button>
          </a-form-item>

      </a-form>
    </a-card>

    <!-- 分组列表 -->
    <a-table :columns="columns" :data-source="data"  :pagination="false" :loading="tLoading" rowKey="id" >
    
      <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
           <span> 
                <router-link  :to="{ path:'alerthistroydetail', query: { id: record.id}}">
                    详情
                </router-link>
          </span>
        </div>
      </template>

    </a-table>

   <a-pagination class="my_pagenation" v-model="pagination.current" :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />
     
  </div>
</template>
<script>
import { mapState } from "vuex";
const data = [];

let pagination={
    total:0,
    pageSize:0,
    current:1,
}
const columns = [
    {
        title: "序号",
        width: 80,
        align: "center",
        customRender: (text, record, index) => {
            let { current, pageSize } = pagination;
            return (Number(current) - 1) * Number(pageSize) + index + 1;
        }
    },
    {
        title: "告警id",
        dataIndex: "id",
        width:120
    },
    {
        title: "告警名称",
        dataIndex: "alertname",
        width:120
    },
    {
        title: "告警消息",
        dataIndex: "msg",
        width:150
    },
    {
        title: "接收人",
        dataIndex: "receivername",
        width:120
    },
    {
        title: "推送通道",
        dataIndex: "channel",
        width:150
    },
    {
        title: "手机号",
        dataIndex: "telephone",
        width:150
    },
    {
        title: "邮箱",
        dataIndex: "email",
        width:150
    },
    {
        title: "钉钉群",
        dataIndex: "dingdingname",
        width:150
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 100,
        scopedSlots: { customRender: 'operation' },
    }

];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            pagination,
            tLoading:true,
            currentItemList:'',
            datasource:{
                isShow:false,
                authedStr:''
            },
        };
    },
    methods: {

        handlePageChange(c_p){
            this.getAlarmHistroyList(c_p)
        },
        getAlarmHistroyList(cpage){
            let c_params = {
                ...this.searchP
            }
           
            c_params.page =cpage ? cpage : 1;
            c_params.pageSize = this.pagination.pageSize;
            c_params.urlparams = false;
            this.tLoading = true;
            this.$store.dispatch({
                type: "alarmconfig/alerthistorylist",
                params:c_params
            }).then((res)=>{
                console.log(res);
                this.tLoading = false;
                let result = res.data.data;
                if(result){
                    this.data = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.current = parseInt(result.page);
                }
            })
        },

        handleSearchReset(){
            this.$store.dispatch({
                type: "alarmconfig/getEmptySearch",
                showMsg: true
            })
        },

        handleSubmit(e){
            e.preventDefault();
            this.getAlarmHistroyList(1)
        },
        
    },
    computed:{
        ...mapState('alarmconfig', {
            searchP: state => state.searchP,
        })
    },

    mounted(){
        const { query } = this.$route;
        this.getAlarmHistroyList(query);
    }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
